import React from "react";
import { Route, Routes } from "react-router-dom";
import { authProtectedRoutes, publicRoutes } from "./routes";
import VerticalLayout from "./components/verticalLayout/index";
import ToastComponent from "./components/toastComponent/toastComponent";

function App(props: any) {
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (!window.localStorage.getItem("accessToken")) {
  //     navigate("/");
  //   }
  // }, []);

  return (
    <React.Fragment>
      <ToastComponent />
      {/* <Loading show={state.LoaderReducer.loader.show} /> */}
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route key={idx} path={route.path} element={route.element} />
        ))}
        {authProtectedRoutes.map((route, idx) => (
          <Route
            key={idx}
            element={<VerticalLayout />}
          >
            <Route path={route.path} element={route.element} />
          </Route>
        ))}
      </Routes>
    </React.Fragment>
  );
}

export default App;
